import React from "react";
import "../../css/components/controls/HrnbRadioButton.css";

export default function HrnbRadioButton({
                                            label,
                                            name,
                                            value,
                                            checked,
                                            onChange,
                                            disabled = false,
                                            className = "",
                                            error = "",
                                            hint = "",
                                            ...props
                                        }) {
    return (
        <label className={`hrnb-radio-wrap ${className} ${disabled ? "hrnb-radio--disabled" : ""}`}>
            <input
                type="radio"
                name={name}
                value={value}
                checked={checked}
                onChange={onChange}
                disabled={disabled}
                className="hrnb-radio-input"
                {...props}
            />
            <span className="hrnb-radio-custom" />
            <span className="hrnb-radio-label">{label}</span>
            {error
                ? <div className="hrnb-radio-error">{error}</div>
                : hint && <div className="hrnb-radio-hint">{hint}</div>
            }
        </label>
    );
}
